// extracted by mini-css-extract-plugin
export default {"scrollContainer":"ModernWarehousesList_scrollContainer__4i4Vu"};